import {vpost} from "@/util/post";

export const saleorder = {
    listAll: async (pageSize, pageNum, keyword, status, client) => {
        const formData = new FormData();
        formData.append('pageSize', pageSize);
        formData.append('pageNum', pageNum);
        formData.append("keyword", keyword);
        if (status) {
            formData.append("status", status);
        }
        if (client) {
            formData.append("client", client);
        }
        return (await vpost("/saleorderAdmin/listAll", formData)).data;
    },

    detail: async (id) => {
        return (await vpost("/saleorderAdmin/getDetail?id=" + id)).data;
    },
    delete: async (id) => {
        return await vpost("/saleorderAdmin/remove?id=" + id);
    },

    listEventOrder: async (saleOrderId) => {
        return (await vpost("/saleorderAdmin/listEventorder?saleOrderId=" + saleOrderId)).data;
    },
    saveEventOrder: async (saleOrderId, eventOrderId) => {
        let formData = new FormData();
        formData.append("saleOrderId", saleOrderId);
        formData.append("eventOrderId", eventOrderId);
        return await vpost("/saleorderAdmin/saveEventorder", formData);
    },
    deleteEventOrderLink: async (saleOrderEventOrderId) => {
        return await vpost("/saleorderAdmin/removeEventorderLink?saleOrderEventOrderId=" + saleOrderEventOrderId);
    },

    updateEventOrderStatus: async (saleOrderEventOrderId, isFinish) => {
        const formData = new FormData();
        formData.append("isFinish", isFinish);
        formData.append("saleOrderEventOrderId", saleOrderEventOrderId);
        return await vpost("/saleorderAdmin/updateSaleOrderEventOrderStatus", formData);
    },

    updateOtherPayment: async (saleOrderId, paymentTime, paymentMethod, payer, receiver, amount, remark) => {
        let dto = {
            saleOrderId: saleOrderId,
            paymentTime: paymentTime,
            paymentMethod: paymentMethod,
            payer: payer,
            receiver: receiver,
            amount: amount,
            remark: remark
        }

        return await vpost("/saleorderAdmin/updateOtherPayment", dto);
    },

    deleteOtherPayment: async (saleOrderId) => {
        return await vpost("/saleorderAdmin/deleteOtherPayment?saleOrderId=" + saleOrderId);
    },

    async getInputOptions() {
        return (await vpost("/saleorderAdmin/getInputOptions")).data;
    },
}
